/* eslint-disable react/prop-types */
import { AmbientpauseIcon, DictateMic } from 'src/icons';
import { endStream } from '../../utils/listen';
import { useAuth } from '@frontegg/react';
import MicrophoneBarExpandIcon from 'src/icons/MicrophoneBarExpand.icon';
import { analytics } from 'src/services';

const MicrophoneBar = ({
  setActiveButton,
  currentActive,
  isRecording,
  setIsRecording,
  setIsStreaming,
  schedulepage = false,
}) => {
  const { user } = useAuth();

  const handlePauseRecording = () => {
    setIsRecording(false);
    setIsStreaming(false);
    endStream();
    const noteType =
      currentActive === 'Pre-chart' ? 'Pre-chart' : 'after-visit';

    if (schedulepage) {
      analytics.track(`Clicked Pause ${noteType} In Ambient From VCA`, {
        email: user?.email,
      });
    } else {
      analytics.track(`Clicked Pause ${noteType} In Ambient From Aura`, {
        email: user?.email,
      });
    }
  };

  const handlePauseResumeToggle = () => {
    if (isRecording) {
      console.log('isRecordingMicro', isRecording);

      handlePauseRecording();
    }
  };

  const handleExpandIcon = () => {
    currentActive === 'Pre-chart'
      ? setActiveButton('Pre-chart')
      : setActiveButton('In visit');
  };
  return (
    <div className="flex flex-col items-start justify-between  bg-[#F5F5F5]  border rounded-lg">
      <div className=" flex justify-between w-full bg-emerald-500 hover:bg-emerald-600 rounded-t-lg ">
        <span className=" flex items-center justify-center gap-1 text-white text-sm  py-2 px-3  focus:outline-none focus:shadow-outline ">
          <DictateMic className="animate-pulse" isFill={true} />
          <span className="text-sm font-medium">Transcription Active</span>
        </span>
        <span
          className="cursor-pointer flex justify-center items-center mr-2 transition-transform duration-200 hover:scale-150"
          onClick={handleExpandIcon}
        >
          <MicrophoneBarExpandIcon />
        </span>
      </div>

      <div className="flex w-full m-1 items-center">
        <div
          id={'pause_record'}
          className="flex items-center justify-center text-white py-2 pl-2 "
          onClick={handlePauseResumeToggle}
        >
          <span className="mt-0 mr-2 p-2 rounded-full cursor-pointer bg-red-200">
            <AmbientpauseIcon isRedFill={true} />
          </span>
        </div>
        <div className="text-black text-sm font-medium mr-4">
          <span className="text-black text-sm font-medium mr-2 ">Pause</span>
          {currentActive === 'Pre-chart' ? 'pre-charting' : 'in-visit'}
        </div>
      </div>
    </div>
  );
};

export default MicrophoneBar;
